module.exports = __webpack_public_path__ + "img/unset_marks.b2e37dd3.svg";